import { render } from "./Icon.vue?vue&type=template&id=6d8fb040&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=6d8fb040&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d8fb040"

export default script